import { render, staticRenderFns } from "./SearchSVG.vue?vue&type=template&id=28771992&scoped=true&"
import script from "./SearchSVG.vue?vue&type=script&lang=js&"
export * from "./SearchSVG.vue?vue&type=script&lang=js&"
import style0 from "./SearchSVG.vue?vue&type=style&index=0&id=28771992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28771992",
  null
  
)

export default component.exports